import React from 'react';
import Text from 'Components/Text';
import Select from 'Components/Select';
import { STATUS } from 'constants/index';

export default ({submittedBy, manufacturerAddress, user, inputErrors, handleSelect, applicationStatus, manufacturerAddresses}) => {
  const getSelectedAddress = (value, possibleItemsList) => {
    return possibleItemsList.find(address => {
      let isSame = true;
      Object.keys(address.value).forEach(addressField => {
        if (address.value[addressField] !== value[addressField]) isSame = false;
      });
      return isSame;
    });
  };

  return (
    <section className='scene_section'>
      <header>Contact details</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Name'
        value={submittedBy ? `${submittedBy.firstName} ${submittedBy.lastName}` : ''}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Email'
        value={submittedBy ? submittedBy.email : ''}
      />
      {(user.isInternal() && applicationStatus !== STATUS.DEACTIVATED) || applicationStatus === STATUS.INCOMPLETE ? (
        <Select
          selectionList={manufacturerAddresses}
          type='primary'
          mainWrapperClassName='_width_pc_100'
          defaultItem={manufacturerAddress ? getSelectedAddress(manufacturerAddress, manufacturerAddresses) : {}}
          label='Select Address *'
          itemNameIndicator='name'
          error={inputErrors.manufacturerAddress}
          handleSelect={handleSelect('manufacturerAddress')}
        />
      ) : (
        <Text
          mainWrapperClassName='text__wrapper_primary _width_pc_100'
          textClassName='text__text_primary'
          label='Address'
          value={
            manufacturerAddress
              ? [
                manufacturerAddress.address1,
                manufacturerAddress.address2,
                manufacturerAddress.address3,
                manufacturerAddress.address4,
                manufacturerAddress.city,
                manufacturerAddress.state,
                manufacturerAddress.postalCode,
                manufacturerAddress.country,
              ]
                .filter(object => object)
                .join(', ')
              : 'N/A'
          }
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Edit/ContactDetails.jsx